import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./menu.css";
import UserDetailsTable from "./userDetailsTable";
import { Link } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import {
  IoTicketOutline,
  IoCreateSharp,
  IoMenu,
  IoCloseCircleOutline,
} from "react-icons/io5";
import { LuUserCog } from "react-icons/lu";
import { FaUserPlus } from "react-icons/fa";
import { SlNote } from "react-icons/sl";
import { AiFillSchedule } from "react-icons/ai";
import { toast } from "react-toastify";
import useuserstore from "../../store/useuserstore";
import { useClientList } from "../../hooks/useClientList";
import Ticket from "../ticketrise/Ticket";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import Clientsettings from "./Clientsettings";
import { CiSettings } from "react-icons/ci";
import Settings from "../settings/Settings";
import { filterProps } from "framer-motion";

function Menu({ tickets, fetchTickets }) {
  const [popupnewuser, setpopupnewuser] = useState("");
  const [userdetails, setuserdetails] = useState([]);
  // const [SelectedClient, setSelectedClient] = useState([]);
  // const [users, setusers] = useState([]);
  // const [tusersize, setTusersize] = useState(""); // from DB, e.g., "1-10"
  // const [tuser, setTuser] = useState(0);
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [isUserDetailsOpen, setisUserDetailsOpen] = useState(false);
  const [isClientDetailsOpen, setisClientDetailsOpen] = useState(false);
  const [CustomShift, setCustomShift] = useState(false);
  const [Customdept, setCustomdept] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const [clientlist, setclientlist] = useState([]);

  const ROLE_MAP = {
    bh: "Business Head",
    cmanager: "Manager",
    user: "User",
  };

  const [newclient, setnewclient] = useState({
    clientlogo: "",
    clientname: "",
    clientcode: "",
    roles: ["bh"],
  });

  // const [newclient, setnewclient] = useState({
  //   clientname: "",
  //   clientcode: "",
  //   roles: ["bh"], // make sure this is an array
  //   mdToggle: false,
  //   approvalWorkflowEnabled: false,
  //   approvalManager: "",
  //   approvalMD: "",
  //   managerPermissions: {
  //     createUser: false,
  //     modifyUser: false,
  //     shiftSchedule: false,
  //   },
  //   EmailPermission: {
  //     create: false,
  //     ticket_raise: false,
  //     ticket_reopen: false,
  //     ticket_close: false,
  //     ticket_hold: false,
  //   },
  // });

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const [newuser, setnewuser] = useState({
    name: "",
    clientname: "",
    contact: "",
    email: "",
    shifttype: "",
    shiftname: "",
    shiftStartTime: "",
    shiftendTime: "",
    deptName: "",
    role: "",
    dept: "",
    password: "",
    confirmpassword: "",
    Approval1: "",
    Approval2: "",
  });

  const [clientid, setclientid] = useState({
    clientid: "",
    role: "",
    client_name: "",
  });

  const [error, seterror] = useState({
    confirmpassword: "",
  });

  // const [users, setusers] = useState([]);
  const setTuser = useuserstore((state) => state.setTuser);
  const setTusersize = useuserstore((state) => state.setTusersize);
  const setusers = useuserstore((state) => state.setusers);

  // Zustand getters (to read global state)
  const tuser = useuserstore((state) => state.Tuser);
  const tusersize = useuserstore((state) => state.Tusersize);
  const users = useuserstore((state) => state.users);
  const { clientlist, SelectedClient, setSelectedClient, refreshClientList } =
    useClientList(userDetails);

  // console.log("menu", SelectedClient);
  const navigate = useNavigate();
  const [filteredshifttimings, setfilteredshifttimings] = useState([]);
  const [filtereddept, setfiltereddept] = useState([]);
  const [filteredbh, setfilteredbh] = useState([]);
  const [filteredcmanager, setfilteredcmanager] = useState([]);

  // const handleSelect = (e) => {
  //   const selectedRole = e.target.value;
  //   if (selectedRole && !newclient.roles.includes(selectedRole)) {
  //     setnewclient((pv) => ({
  //       ...pv,
  //       roles: [...pv.roles, selectedRole],
  //     }));
  //   }
  // };

  // const handleSelect = (e) => {
  //   const value = e.target.value;

  //   setnewclient((prev) => {
  //     const roles = Array.isArray(prev.roles) ? prev.roles : [];

  //     if (roles.includes(value)) return prev;

  //     return { ...prev, roles: [...roles, value] };
  //   });
  // };

  const handleSelect = (e) => {
    const value = e.target.value;

    setnewclient((prev) => {
      const roles = Array.isArray(prev.roles) ? prev.roles : ["bh"];

      // Always ensure bh is included
      const newRoles = [...roles];
      if (!newRoles.includes("bh")) newRoles.unshift("bh");

      if (!newRoles.includes(value)) newRoles.push(value);

      return { ...prev, roles: newRoles };
    });
  };

  const handleRemove = (role) => {
    // Prevent removing Managing Director
    if (role === "bh") return;

    setnewclient((pv) => ({
      ...pv,
      roles: pv.roles.filter((r) => r !== role),
    }));
  };

  const handleCreateClient = async () => {
    // const roleMap = {
    //   "Managing Director": "md",
    //   Manager: "cmanager",
    // };

    // const roleCodes = (newclient?.roles || []).map(
    //   (role) => roleMap[role] || role
    // );
    // formData.append("client_roles", roleCodes.join(","));

    // // 🔹 Add MD toggle
    // formData.append("md", newclient?.mdToggle ? "1" : "0");

    // // 🔹 Add Manager permissions only if cmanager exists
    // if (roleCodes.includes("cmanager")) {
    //   formData.append(
    //     "create",
    //     newclient?.managerPermissions?.createUser ? "1" : "0"
    //   );
    //   formData.append(
    //     "modify",
    //     newclient?.managerPermissions?.modifyUser ? "1" : "0"
    //   );
    //   formData.append(
    //     "shift",
    //     newclient?.managerPermissions?.shiftSchedule ? "1" : "0"
    //   );
    // }

    if (!newclient?.clientcode || !newclient?.clientname) {
      toast.error("Please select both Client Code and Client Name");
      return;
    }
    if (
      newclient?.approvalWorkflowEnabled &&
      !newclient?.approvalManager &&
      !newclient?.approvalMD
    ) {
      toast.error("Please select any one Approval");
      return;
    }
    try {
      setIsSubmitting(true);

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createclient.php`;
      const formData = new FormData();

      // 🔹 Basic client details
      formData.append("subid", userDetails?.sub || "");
      formData.append("logo", newclient?.clientlogo || "");
      formData.append("client_name", newclient?.clientname || "");
      formData.append("client_code", newclient?.clientcode || "");
      formData.append("client_roles", newclient?.roles || []);

      // 🔹 Role Permissions (Managing Director / Manager)
      formData.append("bh", newclient?.mdToggle);

      // approval method system
      if (newclient?.approvalWorkflowEnabled) {
        formData.append("approval_bh", newclient?.approvalMD);
      }
      if (newclient?.roles.includes("cmanager")) {
        formData.append("create", newclient?.managerPermissions.createUser);
        formData.append("modify", newclient?.managerPermissions.modifyUser);
        formData.append("shift", newclient?.managerPermissions.shiftSchedule);

        // approval method system
        if (newclient?.approvalWorkflowEnabled) {
          formData.append("approval_cmanager", newclient?.approvalManager);
        }
      }

      // 🔹 Email Permissions (common for all users)
      formData.append("email_create", newclient.EmailPermission.create);
      formData.append("email_raise", newclient.EmailPermission.ticket_raise);
      formData.append("email_reopen", newclient.EmailPermission.ticket_reopen);
      formData.append("email_close", newclient.EmailPermission.ticket_close);
      formData.append("email_hold", newclient.EmailPermission.ticket_hold);

      // 🔹 report Download (common for all users)
      // formData.append("email_create", newclient.ReportDownload.);
      // formData.append("email_raise", newclient.ReportDownload.);
      // formData.append("email_reopen", newclient.ReportDownload.);
      // formData.append("email_close", newclient.ReportDownload.);
      // formData.append("email_hold", newclient.ReportDownload.);
      // Append all ReportDownload keys and values directly
      const Report = [
        "ticket_des",
        "contact",
        "a1_details",
        "a2_details",
        "ticket_assigned_name",
        "ticket_remarks",
        "ticket_landed_time",
        "ticket_created_time",
        "ticket_closed_time",
        "ticket_time_taken",
      ];
      Report.forEach((key) => {
        formData.append(`R_${key}`, newclient.ReportDownload[key]);
      });

      // console.log("📤 Sending to API:", Object.fromEntries(formData));

      // 🔹 Make the API call
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log("✅ API Response:", data);

      if (data.status === "success") {
        toast.success(data.message || "Client created successfully!");
        // Reset form
        setnewclient({
          clientname: "",
          clientcode: "",
          roles: ["bh"],
        });
        setpopupnewuser("");
        await refreshClientList();
        // const updatedList = [...clientlist, { ...newclient }];
        // setClientlist(updatedList);
      } else {
        toast.error(data.message || "Failed to create client.");
      }
    } catch (error) {
      console.error("❌ Error with POST request:", error);
      toast.error("Something went wrong while creating the client!");
    } finally {
      setIsSubmitting(false);
    }
  };

  // user create
  const getMaxUserFromSize = (size) => {
    if (!size) return 0;
    if (size.includes("+")) return Infinity;
    const [_, max] = size.split("-").map(Number);
    return max;
  };

  const getuserdetails = async () => {
    if (!clientlist || !clientlist.length) return;
    // const { setTuser, setTusersize } = useuserstore();
    const selectedClient = clientlist.find(
      (item) => String(item.id) === String(clientid.clientid)
    );
    setclientid((pv) => ({
      ...pv,
      client_name: selectedClient?.client_name || userDetails?.client_name,
    }));

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getuserdetails.php`;

    try {
      const formData = new FormData();
      formData.append("sub", userDetails?.sub);
      if (userDetails?.role === "admin") {
        formData.append("role", userDetails?.role);
      } else {
        formData.append("client_id", userDetails?.clientid);
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.message === "Records fetched successfully") {
        const fetchedData = data.data || [];

        const filteredUsers =
          userDetails?.role === "cmanager" || userDetails?.role === "bh"
            ? fetchedData.filter(
                (item) =>
                  item.client_id?.toString() ===
                  userDetails.clientid?.toString()
              )
            : clientid?.role !== "client"
            ? fetchedData.filter((item) => item.role === clientid.role)
            : fetchedData.filter(
                (item) =>
                  item.client_id?.toString() === clientid.clientid?.toString()
              );

        setuserdetails(filteredUsers);
        setusers(data.data);
        setTuser(data.data.length);
        setTusersize(data.company_size);
      } else {
        setuserdetails([]);
        setusers([]);
      }
    } catch (error) {
      console.error("Error with POST request:", error);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    const maxUsersAllowed = getMaxUserFromSize(tusersize);

    // ✅ Limit check
    if (tuser >= maxUsersAllowed) {
      alert(
        "Unable to add more users — maximum limit reached. Contact the owner to upgrade your plan"
      );
      setnewuser({
        name: "",
        clientname: "",
        contact: "",
        email: "",
        shifttype: "",
        shiftname: "",
        shiftStartTime: "",
        shiftendTime: "",
        role: "",
        password: "",
        confirmpassword: "",
      });
      setpopupnewuser("");
      return;
    }

    const requiredFieldsFilled =
      (newuser?.name &&
        newuser?.contact &&
        newuser?.email &&
        newuser?.role &&
        newuser?.password &&
        newuser?.confirmpassword) ||
      (["user", "cmanager"].includes(newuser.role)
        ? newuser.clientname
        : true) ||
      (["imanager", "icoordinator", "support"].includes(newuser.role)
        ? newuser.shifttype
        : true);

    if (!requiredFieldsFilled) {
      alert("Please enter all the required fields");
      return;
    }

    if (newuser.password !== newuser.confirmpassword) {
      seterror((prev) => ({
        ...prev,
        confirmpassword: "Please ensure both passwords match!",
      }));
      setnewuser((prev) => ({
        ...prev,
        password: "",
        confirmpassword: "",
      }));
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createuser.php`;
    const formData = new FormData();

    formData.append("user_name", newuser.name);
    formData.append("email", newuser.email);
    formData.append("password", newuser.password);
    formData.append("phone_no", newuser.contact);
    formData.append("role", newuser.role);
    formData.append("dept", newuser.dept);

    // approval
    if (["user", "cmanager"].includes(newuser.role)) {
      formData.append("approval1", newuser?.Approval1);
      formData.append("approval2", newuser?.Approval2);
    }

    formData.append("subid", userDetails?.sub);

    if (["user", "cmanager", "bh"].includes(newuser.role)) {
      formData.append("client_id", newuser.clientname || userDetails?.clientid);
    } else {
      formData.append("client_id", "");
    }

    if (["support", "user"].includes(newuser.role)) {
      formData.append("current_shift", newuser.shifttype);
      formData.append("assign_id", userDetails?.id);
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data?.status === "success") {
        setnewuser({
          name: "",
          clientname: "",
          contact: "",
          email: "",
          shifttype: "",
          shiftname: "",
          shiftStartTime: "",
          shiftendTime: "",
          role: "",
          password: "",
          confirmpassword: "",
        });
        setpopupnewuser("");
        getuserdetails();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error with POST request:", error);
    }
  };

  // const getclientlist = async () => {
  //   const selectedClient = clientlist.find(
  //     (item) => String(item.id) === String(clientid.clientid)
  //   );
  //   setclientid((pv) => ({
  //     ...pv,
  //     client_name: selectedClient?.client_name || userDetails?.client_name,
  //   }));

  //   try {
  //     const formData = new FormData();
  //     formData.append("sub", userDetails?.sub);

  //     const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getclientlist.php`;
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const result = await response.json();
  //     if (result.message === "Records fetched successfully") {
  //       setclientlist(result.data); // unwanted state runing
  //       const filteredClient = result.data.find(
  //         (i) => i.id == clientid?.clientid
  //       );
  //       setSelectedClient(filteredClient);

  //       if (filteredClient) {
  //         const parsedRoles = filteredClient.roles
  //           ? filteredClient.roles.split(",").map((r) => r.trim())
  //           : [];

  //         setSelectedClient({ ...filteredClient, roles: parsedRoles });
  //         console.table(filteredClient);
  //       }
  //     } else {
  //       console.error("Unexpected response:", result);
  //     }
  //   } catch (error) {
  //     console.log("Error fetching client list:", error);
  //   }
  // };

  const handlecustomshift = async (e) => {
    e.preventDefault();

    const { shiftname, shiftStartTime, shiftendTime } = newuser;

    if (!shiftname || !shiftStartTime || !shiftendTime) {
      alert("Please enter all shift details");
      return;
    }

    // Convert 12-hour time string to minutes for validation
    const parseTime = (timeStr) => {
      const [time, period] = timeStr.split(" ");
      let [hours, minutes] = time.split(":").map(Number);
      if (period === "PM" && hours !== 12) hours += 12;
      if (period === "AM" && hours === 12) hours = 0;
      return hours * 60 + minutes;
    };

    // Convert minutes back to 12-hour format
    const formatTime = (minutes) => {
      let hrs = Math.floor(minutes / 60);
      let mins = minutes % 60;
      const period = hrs >= 12 ? "PM" : "AM";
      if (hrs === 0) hrs = 12;
      if (hrs > 12) hrs -= 12;
      const minsStr = mins < 10 ? `0${mins}` : mins;
      return `${hrs}:${minsStr} ${period}`;
    };

    const startMinutes = parseTime(shiftStartTime);
    const endMinutes = parseTime(shiftendTime);

    if (endMinutes <= startMinutes) {
      alert("End time must be greater than start time");
      return;
    }

    const formData = new FormData();
    formData.append("shift_name", shiftname);
    formData.append(
      "shift_time",
      `${formatTime(startMinutes)} - ${formatTime(endMinutes)}`
    );
    formData.append("client_id", newuser?.clientname || userDetails?.clientid);
    formData.append("sub_id", userDetails?.sub);

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createshift.php`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data?.status === "success") {
        toast.success("Shift created successfully!");
        setCustomShift(false);
        setnewuser({
          shiftname: "",
          shiftStartTime: "",
          shiftendTime: "",
        });
      } else {
        toast.error("Error: " + (data.message || "Something went wrong"));
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while creating the shift");
    }
  };

  const handlecustomdept = async (e) => {
    e.preventDefault();

    if (!newuser?.deptName) {
      alert("Please enter all shift details");
      return;
    }

    const formData = new FormData();
    formData.append("dept", newuser?.deptName);
    formData.append("client_id", newuser?.clientname || userDetails?.clientid);
    formData.append("sub_id", userDetails?.sub);

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/createdept.php`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data?.status === "success") {
        toast.success("Department updated successfully");
        refreshClientList();
        setCustomShift(false);
        setnewuser({
          shiftname: "",
          shiftStartTime: "",
          shiftendTime: "",
        });
      } else {
        toast.error("Error: " + (data.message || "Something went wrong"));
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while creating the shift");
    }
  };

  const navigate2shift = () => {
    navigate("/shiftschedule");
  };

  useEffect(() => {
    // getclientlist();
    getuserdetails();
    setuserdetails();
    setusers();
  }, []);

  // useEffect(() => {
  //   if (!userDetails) return;
  //   if (userDetails?.role === "admin") {
  //     // shift
  //     const adminShifts = shifttimings.filter(
  //       (shift) =>
  //         String(shift.client_id) ===
  //         String(newuser?.clientname || userDetails?.clientid)
  //     );
  //     setfilteredshifttimings(adminShifts);

  //     // approvals
  //     const matchingClients = (users || []).filter(
  //       (u) => String(u.client_id) === String(newuser?.clientname)
  //     );
  //     const cmanager = matchingClients.filter((u) => u.role === "cmanager");
  //     setfilteredcmanager(cmanager);
  //     const bh = matchingClients.filter((u) => u.role === "bh");
  //     setfilteredbh(bh);
  //   } else {
  //     // approvals
  //     const matchingClients = (users || []).filter(
  //       (u) => String(u.client_id) === String(userDetails?.clientid)
  //     );
  //     console.log(matchingClients);
  //     const cmanager = matchingClients.filter((u) => u.role === "cmanager");
  //     setfilteredcmanager(cmanager);
  //     const bh = matchingClients.filter((u) => u.role === "bh");
  //     setfilteredbh(bh);

  //     // shifts
  //     const clientShifts = shifttimings.filter(
  //       (shift) => shift.client_id === userDetails?.clientid
  //     );
  //     setfilteredshifttimings(clientShifts);
  //   }
  // }, [
  //   newuser?.clientname,
  //   userDetails?.role,
  //   shifttimings,
  //   userDetails?.clientid,
  //   // userDetails?.clientcode,
  // ]);

  useEffect(() => {
    if (!newuser?.clientname) return; // newuser.clientname = clientid

    // 1️⃣ Find selected client
    const selectedClient = clientlist.find(
      (client) => String(client.id) === String(newuser.clientname)
    );

    if (!selectedClient) {
      setfilteredshifttimings([]);
      setfiltereddept([]);
      setfilteredcmanager([]);
      setfilteredbh([]);
      return;
    }

    // 2️⃣ SHIFT TIMINGS (object → array)
    if (selectedClient.shift_timings) {
      const shiftsArray = Object.entries(selectedClient.shift_timings).map(
        ([key, value]) => ({
          id: key,
          ...value,
        })
      );
      setfilteredshifttimings(shiftsArray);
    } else {
      setfilteredshifttimings([]);
    }

    // 3️⃣ DEPARTMENT (YOUR DATA IS AN ARRAY OF OBJECTS)
    if (Array.isArray(selectedClient.department)) {
      const deptArray = selectedClient.department.map((deptObj, index) => {
        const key = Object.keys(deptObj)[0]; // e.g. dept1
        return {
          id: index,
          dept: deptObj[key],
        };
      });

      setfiltereddept(deptArray);
    } else {
      setfiltereddept([]);
    }

    // 4️⃣ Filter CManager and BH users for this client
    const clientUsers = (users || []).filter(
      (u) => String(u.client_id) === String(newuser.clientname)
    );

    setfilteredcmanager(clientUsers.filter((u) => u.role === "cmanager"));
    setfilteredbh(clientUsers.filter((u) => u.role === "bh"));
  }, [newuser?.clientname, clientlist, users]);

  useEffect(() => {
    const activeClientId =
      userDetails?.role === "admin"
        ? newuser?.clientname // admin selects client
        : userDetails?.clientid; // normal user → own client

    if (!activeClientId) return;

    // 1️⃣ Find selected client
    const selectedClient = clientlist?.find(
      (client) => String(client.id) === String(activeClientId)
    );

    if (!selectedClient) {
      setfilteredshifttimings([]);
      setfiltereddept([]);
      setfilteredcmanager([]);
      setfilteredbh([]);
      return;
    }

    // 2️⃣ SHIFT TIMINGS (object → array)
    if (selectedClient.shift_timings) {
      const shiftsArray = Object.entries(selectedClient.shift_timings).map(
        ([key, value]) => ({
          id: key,
          ...value,
        })
      );
      setfilteredshifttimings(shiftsArray);
    } else {
      setfilteredshifttimings([]);
    }

    // 3️⃣ DEPARTMENT (array of objects)
    if (Array.isArray(selectedClient.department)) {
      const deptArray = selectedClient.department.map((deptObj, index) => {
        const key = Object.keys(deptObj)[0];
        return {
          id: index,
          dept: deptObj[key],
        };
      });

      setfiltereddept(deptArray);
    } else {
      setfiltereddept([]);
    }

    // 4️⃣ Filter CManager & BH users
    const clientUsers = (users || []).filter(
      (u) => String(u.client_id) === String(activeClientId)
    );

    setfilteredcmanager(clientUsers.filter((u) => u.role === "cmanager"));
    setfilteredbh(clientUsers.filter((u) => u.role === "bh"));
  }, [
    newuser?.clientname,
    userDetails?.clientid,
    userDetails?.role,
    clientlist,
    users,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        // setIsSubmenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const submenuRef = useRef(null);
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setIsSubmenuOpen(false);
        setIsLocked(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const [newclient, setNewclient] = useState({
  //   roles: ["Manager", "Managing Director"],
  //   // ...other client data
  // });

  // Handler to receive updates from Clientsettings
  const handleClientSettingsChange = (updatedSettings) => {
    setnewclient((prev) => ({ ...prev, ...updatedSettings }));
  };

  // ✅ Function to get and select the client
  const handleGetClient = async () => {
    try {
      // 1️⃣ Refresh list from server
      await refreshClientList();

      const ID = ["cmanager", "bh"].includes(userDetails?.role || "")
        ? userDetails?.clientid
        : clientid?.clientid;

      const filteredClient = clientlist.find((i) => i.id == ID);
      console.log(ID);
      if (filteredClient) {
        // 3️⃣ ALWAYS normalize roles to array
        const fixedRoles = normalizeRoles(filteredClient.roles);

        // 4️⃣ Update SelectedClient
        setSelectedClient({
          ...filteredClient,
          roles: fixedRoles,
        });

        // 5️⃣ Open the details section
        setisClientDetailsOpen(true);
      } else {
        toast.error("Selected client not found.");
      }
    } catch (err) {
      console.error("Error fetching or selecting client:", err);
      toast.error("Something went wrong while fetching client.");
    }
  };

  const modifyClient = async () => {
    if (
      newclient?.approvalWorkflowEnabled &&
      !newclient?.approvalManager &&
      !newclient?.approvalMD
    ) {
      toast.error("Please select any one Approval");
      return;
    }

    try {
      const formData = new FormData();

      formData.append("client_id", SelectedClient?.id);
      formData.append("client_name", SelectedClient?.client_name);
      formData.append("client_code", SelectedClient?.client_code);
      formData.append("client_roles", newclient?.roles || []);
      formData.append("tic_status", newclient?.Ticket);

      formData.append("bh", newclient?.mdToggle);

      if (newclient?.approvalWorkflowEnabled) {
        formData.append("approval_bh", newclient?.approvalMD);
      }
      if (newclient?.roles.includes("cmanager")) {
        formData.append("create", newclient?.managerPermissions.createUser);
        formData.append("modify", newclient?.managerPermissions.modifyUser);
        formData.append("shift", newclient?.managerPermissions.shiftSchedule);

        // approval method system
        if (newclient?.approvalWorkflowEnabled) {
          formData.append("approval_cmanager", newclient?.approvalManager);
        }
      }

      formData.append("email_create", newclient.EmailPermission.create);
      formData.append("email_raise", newclient.EmailPermission.ticket_raise);
      formData.append("email_reopen", newclient.EmailPermission.ticket_reopen);
      formData.append("email_close", newclient.EmailPermission.ticket_close);
      formData.append("email_hold", newclient.EmailPermission.ticket_hold);

      // 🔹 report Download (common for all users)
      // formData.append("email_create", newclient.ReportDownload.);
      // formData.append("email_raise", newclient.ReportDownload.);
      // formData.append("email_reopen", newclient.ReportDownload.);
      // formData.append("email_close", newclient.ReportDownload.);
      // formData.append("email_hold", newclient.ReportDownload.);
      // Append all ReportDownload keys and values directly

      const Report = [
        "ticket_des",
        "contact",
        "a1_details",
        "a2_details",
        "ticket_assigned_name",
        "ticket_remarks",
        "ticket_landed_time",
        "ticket_created_time",
        "ticket_closed_time",
        "ticket_time_taken",
      ];
      Report.forEach((key) => {
        formData.append(`R_${key}`, newclient.ReportDownload[key]);
      });

      console.table(newclient?.ReportDownload);

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyclient.php`;
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.status === "success") {
        setisClientDetailsOpen(false);
        setpopupnewuser(false);
      } else {
        console.error("Unexpected response:", result);
      }
    } catch (error) {
      console.log("Error fetching client list:", error);
    }
  };

  const normalizeRoles = (roles) => {
    let arr = [];

    if (Array.isArray(roles)) arr = roles;
    else if (typeof roles === "string" && roles.trim())
      arr = roles.split(",").map((r) => r.trim());

    // Always ensure "bh" is present
    if (!arr.includes("bh")) arr.unshift("bh");

    return arr;
  };

  useEffect(() => {
    if (SelectedClient) {
      setnewclient((prev) => ({
        ...prev,
        ...SelectedClient,
        roles: normalizeRoles(SelectedClient.roles),
      }));
    }
  }, [SelectedClient]);

  return (
    <div>
      <div className="admin-portal-container">
        <div className="admin-portal-menu">
          <div className="admin-portal-menu-dropdown">
            <button
              className="admin-portal-menu-button"
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                getuserdetails();
                setIsSubmenuOpen(false);
              }}
            >
              <IoMenu className="admin-portal-svg-icon" />
            </button>

            {isMenuOpen && (
              <div className="admin-portal-menu-box" ref={menuRef}>
                {userDetails?.role === "admin" && (
                  <button
                    className="admin-portal-menu-item"
                    onClick={() => setpopupnewuser("newclient")}
                  >
                    <IoCreateSharp /> CREATE NEW CLIENT
                  </button>
                )}

                {userDetails?.role !== "icoordinator" && (
                  <>
                    <button
                      className={`admin-portal-menu-item ${
                        isSubmenuOpen ? "active" : ""
                      }`}
                      onMouseEnter={() => {
                        if (
                          !isLocked &&
                          userDetails?.role !== "cmanager" &&
                          userDetails?.role !== "bh"
                        ) {
                          setIsSubmenuOpen(true);
                        }
                      }}
                      onMouseLeave={() => {
                        if (
                          !isLocked &&
                          userDetails?.role !== "cmanager" &&
                          userDetails?.role !== "bh"
                        ) {
                          setIsSubmenuOpen(false);
                        }
                      }}
                      onClick={() =>
                        userDetails?.role !== "admin"
                          ? (() => {
                              setpopupnewuser("clientuser");
                            })()
                          : (() => {
                              setIsLocked((prev) => !prev);
                              setIsSubmenuOpen(true);
                            })()
                      }
                    >
                      <FaUserPlus /> CREATE NEW USERS
                    </button>

                    {tuser !== 1 && (
                      <button
                        className="admin-portal-menu-item"
                        onClick={() => {
                          setpopupnewuser("modifyuser");
                          if (
                            userDetails?.role === "cmanager" ||
                            userDetails?.role === "bh"
                          ) {
                            setisUserDetailsOpen(true);
                          }
                        }}
                      >
                        <LuUserCog /> MODIFY & UPDATE
                      </button>
                    )}
                  </>
                )}

                {tickets === 0 ? null : (
                  <Link to="/reports" state={{ clientlist, users }}>
                    <button className="admin-portal-menu-item">
                      <SlNote /> REPORTS
                    </button>
                  </Link>
                )}

                {((userDetails?.role === "bh" &&
                  users?.some((user) => user?.role === "user")) ||
                  (userDetails?.role === "cmanager" &&
                    users?.some((user) => user?.role === "user")) ||
                  (userDetails?.role === "admin" &&
                    users?.some((user) => user?.role === "support"))) && (
                  <button
                    onClick={navigate2shift}
                    className="admin-portal-menu-item"
                  >
                    <AiFillSchedule /> SHIFT SCHEDULE
                  </button>
                  // </Link>
                )}

                <button
                  className="admin-portal-menu-item"
                  onClick={() => {
                    setpopupnewuser("settings");
                    if (
                      userDetails?.role === "cmanager" ||
                      userDetails?.role === "bh"
                    ) {
                      handleGetClient();
                    }
                  }}
                >
                  <CiSettings /> SETTINGS
                </button>

                {(userDetails?.role === "cmanager" ||
                  userDetails?.role === "bh") && (
                  <button
                    className="admin-portal-menu-item"
                    onClick={() => setpopupnewuser("newticket")}
                  >
                    <IoTicketOutline /> RAISE A TICKET
                  </button>
                )}
              </div>
            )}

            {isSubmenuOpen && (
              <div className="admin-portal-submenu-box">
                <div ref={submenuRef} style={{ position: "relative" }}>
                  <button
                    className="admin-portal-menu-item"
                    onClick={() => {
                      setpopupnewuser("clientuser");
                      setIsSubmenuOpen(false);
                    }}
                  >
                    CLIENT USERS
                  </button>

                  <button
                    className="admin-portal-menu-item"
                    onClick={() => {
                      setpopupnewuser("internaluser");
                      setIsSubmenuOpen(false);
                    }}
                  >
                    INTERNAL USERS
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* create client  */}
          {popupnewuser === "newclient" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Create New Client</h2>
                </div>

                <div className="admin-portal-form-section">
                  <div
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    {/* {name} */}
                    <span className="admin-portal-label">Client Name: </span>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      required
                      value={newclient?.clientname}
                      onChange={(e) =>
                        setnewclient((pv) => ({
                          ...pv,
                          clientname: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* {code} */}
                    <span className="admin-portal-label">Client Code: </span>
                    <input
                      type="text"
                      placeholder="Enter Code"
                      required
                      value={newclient?.clientcode}
                      onChange={(e) =>
                        setnewclient((pv) => ({
                          ...pv,
                          clientcode: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* {logo} */}
                    <span className="admin-portal-label">Client logo: </span>
                    <input
                      type="file"
                      // accept="image/*"
                      required
                      // value={newclient?.clientlogo}
                      onChange={(e) =>
                        setnewclient((pv) => ({
                          ...pv,
                          clientlogo: e.target.files[0],
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* {roles} */}
                    <span className="admin-portal-label">Selected Roles:</span>
                    <div className="role-selector-container">
                      {/* <div className="selected-roles-container">
                        {newclient.roles.map((role) => (
                          <div
                            key={role}
                            className={`role-tag ${
                              role === "Managing Director" ? "fixed-role" : ""
                            }`}
                          >
                            <span className="role-name">{role}</span>
                            {role !== "Managing Director" && (
                              <IoCloseCircleOutline
                                className="remove-icon"
                                onClick={() => handleRemove(role)}
                              />
                            )}
                          </div>
                        ))}
                      </div> */}

                      {/* Selected Roles Display */}
                      <div className="selected-roles-container">
                        {(Array.isArray(newclient.roles) &&
                        newclient.roles.length > 0
                          ? newclient.roles
                          : ["bh"]
                        ) // default role
                          .map((roleCode) => (
                            <div
                              key={roleCode}
                              className={`role-tag ${
                                roleCode === "bh" ? "fixed-role" : ""
                              }`}
                            >
                              <span className="role-name">
                                {ROLE_MAP[roleCode]}
                              </span>
                              {roleCode !== "bh" && (
                                <IoCloseCircleOutline
                                  className="remove-icon"
                                  onClick={() => handleRemove(roleCode)}
                                />
                              )}
                            </div>
                          ))}
                      </div>

                      {/* Role Select Dropdown */}
                      <select
                        onChange={handleSelect}
                        defaultValue="" // <-- Correct way to show placeholder
                        className="admin-portal-input role-select-dropdown"
                      >
                        <option value="" disabled>
                          Select Role
                        </option>
                        <option value="cmanager">Manager</option>
                        <option value="user">User</option>
                      </select>
                    </div>

                    {/* {settings}} */}
                    <Clientsettings
                      newclient={newclient}
                      onChange={handleClientSettingsChange}
                    />

                    <button
                      onClick={() => {
                        handleCreateClient();
                      }}
                      className="admin-portal-btn-create"
                    >
                      Create
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* create user  */}
          {(popupnewuser === "clientuser" ||
            popupnewuser === "internaluser") && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">
                    Create{" "}
                    {popupnewuser === "clientuser"
                      ? "Client User"
                      : "Internal User"}
                  </h2>
                </div>

                <div className="admin-portal-form-section">
                  <form
                    onSubmit={handleCreateUser}
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    {/* client  */}
                    {popupnewuser === "clientuser" && (
                      <>
                        <span className="admin-portal-label">
                          Client Name:{" "}
                        </span>
                        {userDetails?.role === "cmanager" ||
                        userDetails?.role === "bh" ? (
                          <div className="admin-portal-input">
                            {userDetails?.clientname}
                          </div>
                        ) : (
                          <>
                            <select
                              required
                              className="admin-portal-select"
                              value={newuser?.clientname}
                              onChange={(e) =>
                                setnewuser((pv) => ({
                                  ...pv,
                                  clientname: e.target.value,
                                }))
                              }
                            >
                              <option value="" disabled>
                                Select Client
                              </option>

                              {clientlist?.map((item) => {
                                return (
                                  <option value={item.id}>
                                    {item.client_code}
                                  </option>
                                );
                              })}
                            </select>
                          </>
                        )}
                      </>
                    )}

                    {/* role  */}
                    <span className="admin-portal-label">Role: </span>
                    <select
                      required
                      className="admin-portal-select"
                      value={newuser?.role}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          role: e.target.value,
                        }))
                      }
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      {popupnewuser === "internaluser" &&
                        userDetails?.role !== "cmanager" && (
                          <>
                            <option value="imanager">Support Manager</option>
                            <option value="icoordinator">
                              Support Coordinator
                            </option>
                            <option value="support">Support Team</option>
                          </>
                        )}

                      {popupnewuser === "clientuser" && (
                        <>
                          <option value="bh">Business Head</option>
                          <option value="cmanager">Manager</option>
                          <option value="user">User</option>
                        </>
                      )}
                    </select>

                    {/* username  */}
                    <span className="admin-portal-label">User Name: </span>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      required
                      value={newuser?.name}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          name: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* ph */}
                    <span className="admin-portal-label">Contact No: </span>
                    <input
                      type="tel"
                      pattern="[0-9]{10}"
                      title="Please enter exactly 10 digits"
                      placeholder="Enter Contact"
                      required
                      value={newuser?.contact}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          contact: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* email */}
                    <span className="admin-portal-label">Email: </span>
                    <input
                      type="email"
                      placeholder="Enter Email"
                      required
                      value={newuser?.email}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          email: e.target.value,
                        }))
                      }
                      className="admin-portal-input"
                    />

                    {/* shift time */}
                    {newuser?.role !== "bh" && (
                      <>
                        {((userDetails?.role !== "cmanager" &&
                          popupnewuser === "clientuser" &&
                          newuser?.clientname) ||
                          (userDetails?.role === "cmanager" &&
                            popupnewuser === "clientuser") ||
                          newuser?.role === "support") && (
                          <>
                            <span className="admin-portal-label">
                              Shift type:{" "}
                            </span>
                            <select
                              required
                              className="admin-portal-select"
                              value={newuser?.shifttype}
                              onChange={(e) => {
                                setnewuser((pv) => ({
                                  ...pv,
                                  shifttype: e.target.value,
                                }));
                                if (e.target.value === "custom shift") {
                                  setCustomShift(true);
                                } else {
                                  setCustomShift(false);
                                }
                              }}
                            >
                              <option value="" disabled defaultChecked>
                                Select Shift
                              </option>

                              {filteredshifttimings.map((shift) => (
                                <option key={shift.id} value={shift.shift_name}>
                                  {shift.shift_name} {shift.shift_time}
                                </option>
                              ))}
                              <option value={"custom shift"}>
                                Create Shift
                              </option>
                            </select>
                          </>
                        )}
                      </>
                    )}

                    {/* dept */}
                    {((userDetails?.role !== "cmanager" &&
                      popupnewuser === "clientuser" &&
                      newuser?.clientname) ||
                      (userDetails?.role === "cmanager" &&
                        popupnewuser === "clientuser") ||
                      (userDetails?.role === "bh" &&
                        popupnewuser === "clientuser") ||
                      newuser?.role === "support") && (
                      <>
                        <span className="admin-portal-label">Department: </span>
                        <select
                          required
                          className="admin-portal-select"
                          value={newuser?.dept}
                          onChange={(e) => {
                            setnewuser((pv) => ({
                              ...pv,
                              dept: e.target.value,
                            }));
                            if (e.target.value === "dept") {
                              setCustomdept(true);
                            } else {
                              setCustomdept(false);
                            }
                          }}
                        >
                          <option value="" disabled defaultChecked>
                            Select Department
                          </option>
                          {filtereddept.map((dept) => (
                            <option key={dept.id} value={dept.dept}>
                              {dept.dept}
                            </option>
                          ))}
                          <option value={"dept"}>Create Department</option>
                        </select>
                      </>
                    )}

                    {/* pass */}
                    <span className="admin-portal-label">Password: </span>
                    <input
                      type="password"
                      placeholder="Enter Password"
                      required
                      className="admin-portal-input"
                      value={newuser?.password}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          password: e.target.value,
                        }))
                      }
                    />

                    {/* confirm pass */}
                    <span className="admin-portal-label">
                      Confirm Password:{" "}
                    </span>
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      required
                      className="admin-portal-input"
                      value={newuser?.confirmpassword}
                      onChange={(e) => {
                        setnewuser((pv) => ({
                          ...pv,
                          confirmpassword: e.target.value,
                        }));

                        if (newuser?.password === e.target.value) {
                          seterror((prev) => ({
                            ...prev,
                            confirmpassword: "",
                          }));
                        }
                      }}
                    />

                    {error.confirmpassword && (
                      <p className="error-msg">{error.confirmpassword}</p>
                    )}

                    {/* approvals  */}
                    {newuser?.role === "user" && (
                      <>
                        {/* Approval 1 */}
                        <span className="admin-portal-label">Approval 1: </span>
                        <select
                          required
                          className="admin-portal-select"
                          value={newuser?.Approval1}
                          onChange={(e) => {
                            setnewuser((pv) => ({
                              ...pv,
                              Approval1: e.target.value,
                            }));
                          }}
                        >
                          <option value="" disabled defaultChecked>
                            Select Shift
                          </option>

                          {filteredcmanager.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.user_name}
                            </option>
                          ))}
                        </select>

                        {/* Approval 2 */}
                        <span className="admin-portal-label">Approval 2: </span>
                        <select
                          required
                          className="admin-portal-select"
                          value={newuser?.Approval2}
                          onChange={(e) => {
                            setnewuser((pv) => ({
                              ...pv,
                              Approval2: e.target.value,
                            }));
                          }}
                        >
                          <option value="" disabled defaultChecked>
                            Select Shift
                          </option>

                          {filteredbh.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.user_name}
                            </option>
                          ))}
                        </select>
                      </>
                    )}

                    <button type="submit" className="admin-portal-btn-create">
                      Create
                    </button>

                    <p
                      style={{
                        marginTop: "10px",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <strong>{tuser}</strong> /{" "}
                      <strong>{getMaxUserFromSize(tusersize)}</strong> Users are
                      Created
                    </p>
                  </form>
                </div>
              </div>
            </div>
          )}
          {CustomShift && (
            <div className="admin-portal-popup-overlay">
              <div className="admin-portal-popup-content">
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => {
                      setCustomShift(false);
                      setnewuser((pv) => ({ ...pv, shifttype: "" }));
                    }}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Custom Shift</h2>
                </div>

                <div className="admin-portal-form-section">
                  <form
                    onSubmit={handlecustomshift}
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    <span className="admin-portal-label">Shift Name: </span>
                    <input
                      type="text"
                      className="admin-portal-input"
                      required
                      value={newuser?.shiftname}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          shiftname: e.target.value,
                        }))
                      }
                    />
                    {/* start time */}
                    <span className="admin-portal-label">Start Time: </span>
                    <TimePicker
                      required
                      className="admin-portal-input"
                      value={newuser.shiftStartTime}
                      onChange={(value) =>
                        setnewuser((pv) => ({ ...pv, shiftStartTime: value }))
                      }
                      format="hh:mm a"
                    />

                    {/* End Time */}
                    <span className="admin-portal-label">End Time: </span>
                    <TimePicker
                      required
                      className="admin-portal-input"
                      value={newuser.shiftendTime}
                      onChange={(value) =>
                        setnewuser((pv) => ({ ...pv, shiftendTime: value }))
                      }
                      format="hh:mm a"
                    />
                    <button type="submit" className="admin-portal-btn-create">
                      Create
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}
          {Customdept && (
            <div className="admin-portal-popup-overlay">
              <div className="admin-portal-popup-content">
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => {
                      setCustomdept(false);
                      setnewuser((pv) => ({ ...pv, dept: "" }));
                    }}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Create Department</h2>
                </div>

                <div className="admin-portal-form-section">
                  <form
                    onSubmit={handlecustomdept}
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    <span className="admin-portal-label">
                      Department Name:{" "}
                    </span>
                    <input
                      type="text"
                      className="admin-portal-input"
                      required
                      value={newuser?.deptName}
                      onChange={(e) =>
                        setnewuser((pv) => ({
                          ...pv,
                          deptName: e.target.value,
                        }))
                      }
                    />
                    {/* start time
                    <span className="admin-portal-label">Start Time: </span>
                    <TimePicker
                      required
                      className="admin-portal-input"
                      value={newuser.shiftStartTime}
                      onChange={(value) =>
                        setnewuser((pv) => ({ ...pv, shiftStartTime: value }))
                      }
                      format="hh:mm a"
                    /> */}

                    {/* End Time
                    <span className="admin-portal-label">End Time: </span>
                    <TimePicker
                      required
                      className="admin-portal-input"
                      value={newuser.shiftendTime}
                      onChange={(value) =>
                        setnewuser((pv) => ({ ...pv, shiftendTime: value }))
                      }
                      format="hh:mm a"
                    /> */}
                    <button type="submit" className="admin-portal-btn-create">
                      Create
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}

          {/* modify user  */}
          {popupnewuser === "modifyuser" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Modify User</h2>
                </div>

                <div className="admin-portal-form-section">
                  <div
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    {userDetails?.role !== "cmanager" &&
                      userDetails?.role !== "bh" && (
                        <>
                          <span className="admin-portal-label">Role: </span>
                          <select
                            required
                            className="admin-portal-select"
                            value={clientid?.role}
                            onChange={(e) =>
                              setclientid((pv) => ({
                                ...pv,
                                role: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled>
                              Select Role
                            </option>

                            <option value="imanager">IT Manager</option>
                            <option value="icoordinator">
                              IT Co-ordinator
                            </option>
                            <option value="support">Support</option>
                            <option value="client">Client</option>
                          </select>

                          {clientid?.role === "client" && (
                            <>
                              <span className="admin-portal-label">
                                Client Name:{" "}
                              </span>
                              <select
                                required
                                className="admin-portal-select"
                                value={clientid?.clientid}
                                onChange={(e) =>
                                  setclientid((pv) => ({
                                    ...pv,
                                    clientid: e.target.value,
                                  }))
                                }
                              >
                                <option value="" disabled>
                                  Select Client
                                </option>

                                {clientlist?.map((item) => {
                                  return (
                                    <option value={item.id}>
                                      {item.client_code}
                                    </option>
                                  );
                                })}
                              </select>
                            </>
                          )}
                          <button
                            onClick={() => {
                              getuserdetails();
                              setisUserDetailsOpen(true);
                            }}
                            className="admin-portal-btn-create"
                          >
                            Get Users
                          </button>
                        </>
                      )}

                    {isUserDetailsOpen && (
                      <div className="admin-portal-user-details">
                        {/* <h3>User Details</h3> */}

                        {isUserDetailsOpen && (
                          <UserDetailsTable
                            userdetails={userdetails}
                            getuserdetails={getuserdetails}
                            dept={filtereddept}
                            approval1={filteredcmanager}
                            approval2={filteredbh}
                            selectedcompany={
                              userDetails.role === "cmanager"
                                ? userDetails?.clientname
                                : userDetails.role === "bh"
                                ? userDetails?.clientname
                                : clientid?.role === "client"
                                ? clientid?.client_name
                                : clientid?.role === "imanager"
                                ? "IT Manager"
                                : clientid?.role === "icoordinator"
                                ? "IT Co-ordinator"
                                : clientid?.role === "support"
                                ? "Support Teams"
                                : null
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* NEW TICKET  */}
          {popupnewuser === "newticket" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">Raise a Ticket</h2>
                </div>

                <div className="admin-portal-form-section">
                  <Ticket handleoldtickets={fetchTickets} />
                </div>
              </div>
            </div>
          )}

          {/* SETTINGS  */}
          {popupnewuser === "settings" && (
            <div className="admin-portal-popup-overlay">
              <div
                className="admin-portal-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="admin-portal-header">
                  <button
                    className="admin-portal-back-btn"
                    onClick={() => setpopupnewuser("")}
                  >
                    <IoMdArrowRoundBack className="admin-portal-svg-icon" />
                  </button>
                  <h2 className="admin-portal-form-title">SETTINGS</h2>
                </div>

                <div className="admin-portal-form-section">
                  <div
                    className={isSubmitting ? "blurred" : "admin-portal-form"}
                  >
                    {userDetails?.role !== "cmanager" &&
                      userDetails?.role !== "bh" && (
                        <>
                          <span className="admin-portal-label">
                            Client Name:{" "}
                          </span>
                          <select
                            required
                            className="admin-portal-select"
                            value={clientid?.clientid}
                            onChange={(e) => {
                              // const selectedId = e.target.value;
                              setclientid((pv) => ({
                                ...pv,
                                clientid: e.target.value,
                              }));
                              // const filtered = clientlist.filter(
                              //   (i) => i.id === selectedId
                              // );
                              // setSelectedClient(filtered);
                            }}
                          >
                            <option value="" disabled>
                              Select Client
                            </option>

                            {clientlist?.map((item) => {
                              return (
                                <option value={item.id}>
                                  {item.client_code}
                                </option>
                              );
                            })}
                          </select>

                          <button
                            onClick={handleGetClient}
                            className="admin-portal-btn-create"
                          >
                            Get Client
                          </button>
                        </>
                      )}

                    {isClientDetailsOpen && SelectedClient && (
                      <div>
                        <div>
                          <Clientsettings
                            SelectedClient={SelectedClient}
                            label={
                              userDetails?.role !== "admin"
                                ? userDetails?.clientname
                                : clientid?.client_name
                            }
                            onChange={handleClientSettingsChange}
                          />
                        </div>

                        <button
                          onClick={modifyClient}
                          className="admin-portal-btn-create"
                        >
                          Modify Client
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Menu;
